import * as z from "zod";

// CongoDB JSONB preserves embedded dates as ISO strings on read.
export const DateFromDateOrIsoStringSchema = z
  .union([z.iso.datetime(), z.date()])
  .pipe(z.coerce.date());
